"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../StoriesAPI/Story/utils");

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
* Component to visualize an achievement.
*/
var AwardCertificate =
/*#__PURE__*/
function (_Component) {
  _inherits(AwardCertificate, _Component);

  function AwardCertificate() {
    _classCallCheck(this, AwardCertificate);

    return _possibleConstructorReturn(this, _getPrototypeOf(AwardCertificate).apply(this, arguments));
  }

  _createClass(AwardCertificate, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          conferred_by = _this$props.conferred_by,
          date = _this$props.date,
          description = _this$props.description,
          icon = _this$props.icon,
          label = _this$props.label,
          name = _this$props.name,
          style = _this$props.style,
          subtitle = _this$props.subtitle;
      var lightCornerStyle = {
        background: color.light
      };
      var darkCornerStyle = {
        background: color.dark
      };
      var leftCornerClass = "award-corner award-corner-left";
      var rightCornerClass = "award-corner award-corner-right";
      var leftBottomCornerClass = "award-corner award-corner-left-bottom";
      var rightBottomCornerClass = "award-corner award-corner-right-bottom";
      return _react.default.createElement("div", {
        className: "story-award-certificate",
        style: style
      }, _react.default.createElement("div", {
        className: rightCornerClass,
        style: lightCornerStyle
      }), _react.default.createElement("div", {
        className: leftCornerClass,
        style: darkCornerStyle
      }), _react.default.createElement("div", {
        className: leftBottomCornerClass,
        style: lightCornerStyle
      }), _react.default.createElement("div", {
        className: rightBottomCornerClass,
        style: darkCornerStyle
      }), _react.default.createElement("div", {
        className: "award-content"
      }, _react.default.createElement("div", {
        className: "award-graphic",
        style: {
          borderColor: color.dark
        }
      }, _react.default.createElement("span", {
        className: "award-icon"
      }, _utils.IconUtils.buildIcon(icon))), _react.default.createElement("div", {
        className: "award-pretitle",
        style: {
          color: color.dark
        }
      }, date.year), _react.default.createElement("div", {
        className: "award-title",
        style: {
          color: color.light
        }
      }, label), _react.default.createElement("div", {
        className: "award-subtitle"
      }, subtitle), _react.default.createElement("div", {
        className: "award-name",
        style: {
          color: color.dark
        }
      }, name), _react.default.createElement("div", {
        className: "award-description"
      }, description), conferred_by && _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "award-organizer",
        style: {
          borderColor: color.dark
        }
      }, conferred_by.title), _react.default.createElement("div", {
        className: "award-organizer-subtext"
      }, "Conferred By"))));
    }
  }]);

  return AwardCertificate;
}(_react.Component);

exports.default = AwardCertificate;

_defineProperty(AwardCertificate, "propTypes", {
  /** Colors to accent the `Certificate` */
  color: _propTypes.default.object,

  /** Who the `Certificate` is presented by. */
  conferred_by: _propTypes.default.object,

  /** When the `Certificate` was awarded. */
  date: _propTypes.default.object,

  /** Smallest text at the bottom of the `Certificate` */
  description: _propTypes.default.string,

  /** Icon to display at the top of the `Certificate` */
  icon: _propTypes.default.object,

  /** The title of the Award */
  label: _propTypes.default.string,

  /** The awardee of the `Certificate` */
  name: _propTypes.default.string,

  /** Styling object of the `Certificate` */
  style: _propTypes.default.object,

  /** Text underneath the title of the `Book` */
  subtitle: _propTypes.default.string,

  /** Largest text at the top of the `Book` */
  title: _propTypes.default.string
});

_defineProperty(AwardCertificate, "defaultProps", {
  icon: {
    name: "FaAward",
    source: "fa"
  },
  style: {}
});